import {useState, useEffect} from 'react';
import styles from "../../assets/stylesheets/sass/Register.module.scss"
import RegisterForm from '../form_elements/RegisterForm';
import Dropdownlist from '../customComponents/Dropdownlist';
import { ReactSession }  from 'react-client-session';
import logo from "../../assets/images/logo.svg";
import logo_white from "../../assets/images/logo_white.svg";

export default function Register({onLogin, language}){
	const [content_state, setcontent_state] = useState({});
	useEffect(()=>{
		const fetchData = async () =>{
           const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
           let res = await data.json();
           setcontent_state(res);
        }
        fetchData();
	}, [])
    const [formLoaded, setFormLoaded] = useState(false);
    const [error, seterror] = useState(false);

	const [lang_updater, setlang_updater] = useState("");
	const handleChangeLanguage = (lang) =>{
		setlang_updater(lang);
		ReactSession.set("language", lang);
	}

	useEffect(()=>{
		setlang_updater(language);
		ReactSession.set("language", language);
	}, [language])

	return (
	    <>  
        <div className={styles.main_container} datatype={lang_updater}>
            <div style={{position:"relative"}} className={styles.left_container}>
				<div style={{marginTop:"-4rem", marginLeft:"4rem"}}>
                    {formLoaded ? <>
                        <p style={{fontSize:"3.7rem"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].Register ? (content_state[ReactSession.get("language")].Register.left_title ? content_state[ReactSession.get("language")].Register.left_title :  "Confirm registration") : ""}</p>
					    <p style={{fontSize:"1rem", marginTop:"1rem"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].Register ? (content_state[ReactSession.get("language")].Register.left_subtitle ? content_state[ReactSession.get("language")].Register.left_subtitle :  "Register to access the portal") : ""}</p>
                    </>
                    :
                    <>
                        <p style={{fontSize:"3.7rem"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].Register ? (content_state[ReactSession.get("language")].Register.left_title_loading ? content_state[ReactSession.get("language")].Register.left_title_loading :  "Verify data") : ""}</p>
					    <p style={{fontSize:"1rem", marginTop:"1rem"}}>{error ? (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].Register ? (content_state[ReactSession.get("language")].Register.left_subtitle_error ? content_state[ReactSession.get("language")].Register.left_subtitle_error :  "Something went wrong...") : "") : (content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].Register ? (content_state[ReactSession.get("language")].Register.left_subtitle_loading ? content_state[ReactSession.get("language")].Register.left_subtitle_loading :  "Please wait...") : "")}</p>
                    </>
                    }
				</div>
                
			</div>
			<div style={{position:"relative"}}>
				<div className={styles.logo_container}>
					<img className={styles.logo} src={logo} alt="logo"/>
					<img className={styles.logo_white} src={logo_white} alt="logo"/>
				</div>
				<div className={styles.login_form}>
					<RegisterForm title="Hier registreren!" formLoaded={(v)=>setFormLoaded(v)} subtitle="Gelieve volgende gegevens te controleren en verder aan te vullen" onError={(v)=>seterror(v)}/>
				</div>
                <div className={styles.language_ddl}>
					<Dropdownlist value={lang_updater} 
                    data={[
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch && content_state[ReactSession.get("language")].General.language_dutch) : "Dutch"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french && content_state[ReactSession.get("language")].General.language_french) : "French"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english && content_state[ReactSession.get("language")].General.language_english) : "English")
                    ]}  menuPlacement="auto" isSearchable={false} defaultValue type="language" width="small" onChange={(v)=>handleChangeLanguage(v)}/>
				</div>
			</div>
		</div>
	    </>  
  	);
}